import type { CardInput, IProvider } from '../types';

const PAGARME_API = 'https://api.pagar.me/core/v5';

export class PagarmeProvider implements IProvider {
  constructor(
    private readonly apiKey: string,
    private readonly gatewayConfigId: string,
  ) {}

  async generate(card: CardInput): Promise<string> {
    const [month, year] = card.expiration.split('/');

    const response = await fetch(`${PAGARME_API}/tokens?appId=${this.apiKey}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'card',
        card: {
          number: card.number,
          holder_name: card.holder,
          holder_document: card.document,
          exp_month: Number(month),
          exp_year: Number(year),
          cvv: card.cvv,
        },
      }),
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Pagarme tokenize failed: ${error}`);
    }

    const data = (await response.json()) as { id: string };
    return data.id;
  }
}
